<div class="go-container">

  <go-card class="go-column go-column--100" id="usage">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Usage</h2>
      <go-copy cardId="usage" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          The <code class="code-block--inline">&lt;go-layout&gt;</code> component should only be used once, at the root level component
          (typically the app component). This component is used to create an application layout that includes routing, navigation, and
          slots in the header for a logo, a search component, and actions.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <h3 class="go-heading-3">Bindings</h3>
        <p class="go-body-copy">
          There are none! Instead, there are four areas used for content projection: <code class="code-block--inline">go-layout-header</code> and
          <code class="code-block--inline">go-layout-nav</code> and <code class="code-block--inline">go-layout-footer</code>. These should be
          applied to the <code class="code-block--inline">&lt;go-header&gt;</code> and <code class="code-block--inline">&lt;go-side-nav&gt;</code>
          and <code class="code-block--inline">&lt;go-footer&gt;</code> components respectively.
        </p>
        <p class="go-body-copy">
          <code class="code-block--inline">go-layout-main</code> can be used to add content that will be shown on every page. A good example of
          this would be notifications that show up at the top of every page. The <code class="code-block--inline">go-layout-main</code> area will
          show up at the top of every page below the header and if a header bar is being used in conjunction, it will be beneath the header bar
          as well.
        </p>
        <p class="go-body-copy go-body-copy--no-margin">
          Check the simple setup example below. 
        </p>
      </div>
    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="setup">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Simple Setup</h2>
      <go-copy cardId="setup" goCopyCardLink></go-copy>
    </ng-container>
    <ng-container go-card-content>
      <p class="go-body-copy">
        For the sake of this example, we'll be referencing the layout of this application because it's a living example of the
        entire layout component and family.
      </p>

      <h4 class="go-heading-4">app.module</h4>
      <code [highlight]="basicExample_module"></code>

      <h4 class="go-heading-4">app.component</h4>
      <code [highlight]="basicExample_html"></code>
    </ng-container>
  </go-card>
</div>
